import Vue from "vue";
import Router from "vue-router";

import Home from "./components/Home.vue";
import ConsultarReserva from "./components/ConsultarReserva.vue";
import DetalleReserva from "./components/DetalleReserva.vue";
import AgendarReserva from "./components/AgendarReserva.vue";

import NProgress from "nprogress";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/agendar",
      name: "agendar",
      component: AgendarReserva,
      meta: {
        breadcrumbs: [
          { name: "Inicio", link: "home" },
          { name: "Agendar hora", link: null }
        ]
      }
    },
    {
      path: "/consultar-reserva",
      name: "consultar-reserva",
      component: ConsultarReserva,
      meta: {
        breadcrumbs: [
          { name: "Inicio", link: "home" },
          { name: "Consultar reserva", link: null }
        ]
      }
    },
    {
      path: "/anular-reserva",
      name: "anular-reserva",
      component: ConsultarReserva,
      meta: {
        breadcrumbs: [
          { name: "Inicio", link: "home" },
          { name: "Anular reserva", link: null }
        ]
      }
    },
    {
      path: "/detalle-reserva/:id",
      name: "detalle-reserva",
      component: DetalleReserva,
      meta: {
        breadcrumbs: [
          { name: "Inicio", link: "home" },
          { name: "Detalle de la reserva", link: null }
        ]
      }
    }
  ]
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
